import { render } from "./rule-msg-box.vue?vue&type=template&id=34083f88&scoped=true&ts=true"
import script from "./rule-msg-box.vue?vue&type=script&lang=ts"
export * from "./rule-msg-box.vue?vue&type=script&lang=ts"

import "./rule-msg-box.vue?vue&type=style&index=0&id=34083f88&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34083f88"]])

export default __exports__